module.exports = __webpack_public_path__ + "static/media/ico_tint_clear_sel.db6f762e.svg";